import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

export const searchGlobal = async ({ query, types, modules, limit = 20, offset = 0, signal } = {}) => {
  const params = new URLSearchParams();
  params.set('q', String(query || '').trim());
  if (types?.length) params.set('types', types.join(','));
  if (modules?.length) params.set('modules', modules.join(','));
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return parseApiResponse(await apiFetch(`/api/search?${params.toString()}`, { signal }));
};
